import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { http, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const inp = "w-full border border-slate-300 rounded-md px-3 py-2 text-sm";

export const ProfileForm = ({ onDone, onCancel }) => {
  const { user, refresh } = useAuth();
  const [f, setF] = useState({ name: user?.name || "", email: user?.email || "", current_password: "", new_password: "" });
  const set = (p) => setF((x) => ({ ...x, ...p }));
  const canPwd = ["admin", "superadmin"].includes(user?.role);
  const save = async () => {
    const body = { name: f.name };
    if (f.email && f.email !== user.email) body.email = f.email;
    if (f.new_password) body.new_password = f.new_password;
    if (body.email || body.new_password) body.current_password = f.current_password;
    try { await http.patch("/auth/me", body); await refresh(); toast.success("Informations mises à jour"); set({ current_password: "", new_password: "" }); onDone?.(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <>
      <div className="space-y-3">
        <label className="block text-xs text-slate-500">Nom affiché (prénom et nom)<input className={inp} value={f.name} onChange={(e) => set({ name: e.target.value })} data-testid="profile-name" /></label>
        <label className="block text-xs text-slate-500">E-mail de connexion<input className={inp} value={f.email} onChange={(e) => set({ email: e.target.value })} data-testid="profile-email" /></label>
        {canPwd ? <label className="block text-xs text-slate-500">Nouveau mot de passe (facultatif)<input type="password" autoComplete="new-password" className={inp} value={f.new_password} onChange={(e) => set({ new_password: e.target.value })} data-testid="profile-new-password" /></label>
          : <p className="text-xs text-slate-500" data-testid="profile-password-admin-only">Mot de passe : seul votre administrateur peut le modifier (rubrique Utilisateurs).</p>}
        {(f.new_password || f.email !== user?.email) && <label className="block text-xs text-slate-500">Mot de passe actuel (obligatoire)<input type="password" className={inp} value={f.current_password} onChange={(e) => set({ current_password: e.target.value })} data-testid="profile-current-password" /></label>}
      </div>
      <div className="flex justify-end gap-2 mt-4">
        {onCancel && <button onClick={onCancel} className="px-4 py-2 text-sm rounded-md border border-slate-300" data-testid="profile-cancel">Annuler</button>}
        <button onClick={save} disabled={f.name.trim().length < 2} className="px-4 py-2 text-sm rounded-md bg-[#0B2A7A] text-white font-semibold disabled:opacity-40" data-testid="profile-save">Enregistrer</button>
      </div>
    </>
  );
};

export const ProfileDialog = ({ open, onClose }) => (
  <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
    <DialogContent className="max-w-md" data-testid="profile-dialog">
      <DialogHeader><DialogTitle className="font-display text-2xl">Mes informations</DialogTitle></DialogHeader>
      <ProfileForm onDone={onClose} onCancel={onClose} />
    </DialogContent>
  </Dialog>
);
